import { RefObject, useEffect, useState } from "react";

const useHeaderMenuPositionTop = (parentRef: RefObject<HTMLDivElement>): number => {
  const [top, setTop] = useState<number>(0);

  useEffect(() => {
    if (parentRef.current) {
      const { height } = parentRef.current.getBoundingClientRect();
      setTop(height);
    }
  }, [parentRef]);

  return top;
};

export default useHeaderMenuPositionTop;
